module.exports = __webpack_public_path__ + "static/narwhale-da856b152bf1ca6117ee55b2d51feb43.png";